<!-- Formulário de cadastro normal (quando não está em modo login) -->
<ng-container *ngIf="!showLoginForm">
    <form [formGroup]="form" (keydown.enter)="handleKeyEnter($event)"
        [class.loading-form]="loading">
        <!-- Spinner no topo durante o loading -->
        <div class="loading-container" *ngIf="loading">
            <app-loading-spinner [active]="true"></app-loading-spinner>
        </div>

        <ng-container *ngIf="!haveToken">
            <div class="row no-gutters">
                <div class="offset-1 col-8">
                    <span class="basic-content-title">
                        Para começar seu cadastro, informe seus dados pessoais
                        abaixo
                    </span>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </ng-container>

        <div class="row no-gutters">
            <div class="offset-1 col-8">
                <h1>{{name}}</h1>
                <app-spacer [bottom]="16"></app-spacer>
                <span class="basic-content-alternative" *ngIf="haveToken">
                    <span *ngIf="inviteExpired">
                        Por favor, entre em contato novamente com o emissor do
                        convite.
                    </span>
                    <span *ngIf="inviteCanceled && !inviteExpired">
                        Este convite foi cancelado e não está mais disponível.
                        Por
                        favor, entre em contato com o emissor do convite para
                        mais
                        informações.
                    </span>
                    <span
                        *ngIf="!inviteUsed && !inviteCanceled && !inviteExpired">
                        Você está recebendo o convite para cadastrar seu
                        perfil<span *ngIf="typeDisplay"> como
                            <strong>{{typeDisplay}}</strong></span> na
                        plataforma da {{'brand.name' | theme}}.
                        Para continuar, preencha o formulário abaixo para criar
                        sua
                        conta de usuário.
                    </span>
                    <span
                        *ngIf="inviteUsed && !inviteCanceled && !inviteExpired">
                        Este convite já foi utilizado e não pode ser usado
                        novamente.
                        Por favor, entre com seus dados de acesso para acessar a
                        plataforma.
                    </span>
                </span>
                <app-spacer [bottom]="24"></app-spacer>
                <!-- Botão de autenticação aparece apenas quando convite já foi usado -->
                <app-button (onClick)="backToLogin()"
                    *ngIf="inviteUsed && !inviteCanceled && !inviteExpired">
                    Faça sua autenticação
                </app-button>

                <!-- Espaçamento apenas quando necessário -->
                <app-spacer [bottom]="24" *ngIf="inviteUsed"></app-spacer>
            </div>

        </div>

        <app-spacer [bottom]="24"></app-spacer>

        <div class="row no-gutters" *ngIf="!disabled">
            <div class="col-12 offset-lg-1 col-lg-11">
                <!-- 1. CPF e Nome completo (mesma linha) -->
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <app-masked-input label="CPF" [group]="form"
                            controlName="document" mask="000.000.000-00"
                            placeholder="000.000.000-00"
                            [readOnly]="haveDocument || loading">
                        </app-masked-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-7">
                        <app-input label="Nome completo" [group]="form"
                            controlName="full_name"
                            helpText="Sem abreviações, como está em seus documentos"
                            [maxLength]="60" [readOnly]="loading">
                        </app-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>

                <!-- 2. Fundo de interesse -->
                <div class="row">
                    <div class="col-12 col-lg-11">
                        <app-select label="Fundo de interesse" [group]="form"
                            controlName="fund" [items]="fundOptions"
                            [readOnly]="haveFund || loading">
                        </app-select>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>

                <!-- Papel (apenas para provider) -->
                <div class="row" *ngIf="userRole === 'provider'">
                    <div class="col-12 col-lg-11">
                        <app-select label="Papel" [group]="form"
                            controlName="agent" [multiple]="true"
                            [items]="agentOptions"
                            [readOnly]="haveRole || loading">
                        </app-select>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>

                <!-- 3. Email, DDI e Telefone (mesma linha - 3 campos) -->
                <div class="row">
                    <div class="col-12 col-lg-5">
                        <app-input label="Seu melhor e-mail" [group]="form"
                            controlName="email" [readOnly]="loading">
                        </app-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>

                    <div class="col-4 col-lg-2">
                        <app-select label="DDI" [group]="form"
                            controlName="phone_ddi" [items]="DDIOptions"
                            placeholder="00" [readOnly]="loading">
                        </app-select>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>

                    <div class="col-8 col-lg-4">
                        <app-masked-input label="Número do seu celular"
                            [group]="form" controlName="phone_number"
                            mask="(00) 00000-0000||(00) 0000-0000"
                            placeholder="(00) 00000-0000" [readOnly]="loading">
                        </app-masked-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>
            </div>

            <div class="col-12 offset-lg-1 col-lg-11">
                <app-radio [multiple]="true" formControlName="terms"
                    [disabled]="loading">
                    <div class="term-text">Declaro que estou de acordo com a
                        <a [routerLink]="['/']">Política de
                            Privacidade</a>
                    </div>
                </app-radio>
            </div>
        </div>
    </form>
</ng-container>

<!-- Formulário de login quando há new_paper e usuário não está autenticado -->
<ng-container *ngIf="showLoginForm">
    <div class="row no-gutters">
        <div class="offset-1 col-8">
            <h1 class="basic-content-title" *ngIf="loginUserName">
                Olá, {{loginUserName}}
            </h1>
            <h1 class="basic-content-title" *ngIf="!loginUserName">
                Olá
            </h1>
            <app-spacer [bottom]="16"></app-spacer>
            <span class="basic-content-alternative">
                Você está recebendo o convite para cadastrar seu perfil<span
                    *ngIf="loginTypeDisplay"> como
                    <strong>{{loginTypeDisplay}}</strong></span><span
                    *ngIf="loginFundName">
                    no fundo <strong>{{loginFundName}}</strong></span> na
                plataforma da {{'brand.name' | theme}}.
                Para continuar, faça o login com seu usuário para concluir o
                cadastro do novo papel.
            </span>
            <app-spacer [bottom]="16"></app-spacer>
            <span class="basic-content-alternative">
                Caso você não seja o dono deste convite, você pode voltar para a
                tela de login para acessar a plataforma.
            </span>
            <app-spacer [bottom]="24"></app-spacer>
            <app-button (onClick)="backToLogin()">
                Voltar para tela de login
            </app-button>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <form [formGroup]="loginForm" (keydown.enter)="validatePassword()">
        <div class="row no-gutters">
            <div class="col-12 offset-lg-1 col-lg-11">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-masked-input label="Informe seu CPF"
                            [group]="loginForm" controlName="username"
                            mask="000.000.000-00" placeholder="000.000.000-00"
                            [readOnly]="loginLoading">
                        </app-masked-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-input label="Insira sua senha" type="password"
                            [group]="loginPasswordForm" controlName="password"
                            placeholder="Digite sua senha"
                            [readOnly]="loginLoading">
                        </app-input>
                        <app-spacer [bottom]="27"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-button
                            [disabled]="!canProceedLogin() || loginLoading"
                            [loading]="loginLoading"
                            (onClick)="validatePassword()">
                            Continuar cadastro
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-container>